// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// const BASE_URL = "https://vishushethra.com/api/api/";
// import { IoArrowBack } from "react-icons/io5";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { IoArrowBack } from "react-icons/io5";

const BASE_URL = "https://vishushethra.com/api/api/";

const Payment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const handleScrollToTop = () => {
      // Check if the screen width is less than or equal to 768px (mobile devices)
      if (window.innerWidth <= 768) {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // Smooth scrolling for better mobile experience
        });
      } else {
        window.scrollTo(0, 0); // Default behavior for larger screens
      }
    };

    handleScrollToTop(); // Call the function on component mount
  }, []);

  const { items } = location.state || { items: [] };

  const [formData, setFormData] = useState({
    firstName: "",
    streetAddress: "",
    city: "",
    state: "",
    country: "",
    pinCode: "",
    phone: "",
    email: "",
  });

  const [billingData, setBillingData] = useState({
    name: "",
    street: "",
    city: "",
    state: "",
    country: "INDIA",
    postalCode: "",
    phone: "",
    email: "",
  });

  const [useShippingAddress, setUseShippingAddress] = useState(true);

  const handleDeliveryChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleBillingChange = (e) => {
    const { name, value } = e.target;
    setBillingData({
      ...billingData,
      [name]: value,
    });
  };

  const handleAddressOptionChange = (option) => {
    setUseShippingAddress(option === "same");
  };
  const validateForm = () => {
    const newErrors = {};

    // Check delivery address fields
    if (!formData.firstName) newErrors.firstName = "Name is required";
    if (!formData.streetAddress)
      newErrors.streetAddress = "Street address is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.pinCode) newErrors.pinCode = "PIN code is required";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    if (!formData.email) newErrors.email = "Email is requried";

    // Check billing address fields if a different billing address is used
    if (!useShippingAddress) {
      if (!billingData.name) newErrors.billingName = "Billing name is required";
      if (!billingData.street)
        newErrors.billingStreet = "Billing street address is required";
      if (!billingData.city) newErrors.billingCity = "Billing city is required";
      if (!billingData.state)
        newErrors.billingState = "Billing state is required";
      if (!billingData.country)
        newErrors.billingCountry = "Billing country is required";
      if (!billingData.postalCode)
        newErrors.billingPostalCode = "Billing PIN code is required";
      if (!billingData.phone)
        newErrors.billingPhone = "Billing phone number is required";
      if (!billingData.email)
        newErrors.billingemail = "Billing Email is requried";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [couponError, setCouponError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const userId = localStorage.getItem("userId");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  useEffect(() => {
    const fetchUserAddress = async () => {
      try {
        let address;

        // Fetch the user address if userId exists, else fetch guest address
        if (userId) {
          const response = await axios.get(
            `${BASE_URL}user-address/${userId}/`,
          );
          address = response.data;
        } else {
          // Fetch guest address (make sure the endpoint exists in your backend)
          const response = await axios.get(`${BASE_URL}guest-address/`);
          address = response.data;
        }

        // If an address exists, update the form data
        if (address) {
          setFormData({
            firstName: address.name || "",
            streetAddress: address.street || "",
            city: address.city || "",
            state: address.state || "",
            country: address.country || "",
            pinCode: address.postal_code || "",
            phone: address.phone || "",
            email: address.email || "", // For guest, ensure email is set if available
          });
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserAddress();
  }, [userId]);

  const [filteredStates, setFilteredStates] = useState([]);

  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep",
    "Delhi",
    "Puducherry",
  ];

  const handleStateChange = (e) => {
    const stateValue = e.target.value;
    setFormData({ ...formData, state: stateValue });
    setShowSuggestions(true);

    if (stateValue.trim() !== "") {
      setFilteredStates(
        states.filter((state) =>
          state.toLowerCase().includes(stateValue.toLowerCase()),
        ),
      );
      setDeliveryCharges(calculateDeliveryCharge(stateValue));
    } else {
      setFilteredStates(states);
      setDeliveryCharges(0); // Reset delivery charge if state field is empty
    }
  };

  const calculateDeliveryCharge = (state) => {
    return state.toLowerCase() === "tamil nadu" ||
      state.toLowerCase() === "tn" ||
      state.toLowerCase() === "tamilnadu" ||
      state.toLowerCase() === "tamilnadu " ||
      state.toLowerCase() === " tamilnadu " ||
      state.toLowerCase() === " tamilnadu"
      ? 65
      : 120;
  };

  const selectState = (state) => {
    setFormData({ ...formData, state });
    setShowSuggestions(false);
    setDeliveryCharges(calculateDeliveryCharge(state));
  };
  const deliveryCharge = calculateDeliveryCharge(formData.state);

  const calculateSubtotal = (items) => {
    return items.reduce((acc, product) => acc + product.item_price, 0);
  };

  const subtotal = calculateSubtotal(items);

  // const total = subtotal + deliveryCharge;
  const total = subtotal + (formData.state.trim() !== "" ? deliveryCharge : 0);

  const discountedTotal = total - discount;

  const cart_item_ids = items.map((item) => item.cart_item_id);

  const applyCoupon = async () => {
    try {
      const response = await axios.get(`${BASE_URL}coupen/`);
      const coupons = response.data;

      // Find the coupon that matches the entered code
      const validCoupon = coupons.find(
        (coupon) => coupon.coupen_code === couponCode,
      );

      if (validCoupon) {
        // Check if the coupon's actual price is greater than or equal to the subtotal
        if (validCoupon.actual_price <= subtotal) {
          let discountAmount = 0;

          if (validCoupon.discount_type === "price") {
            // Apply fixed price discount
            discountAmount = validCoupon.discount_price;
          } else if (validCoupon.discount_type === "percentage") {
            // Apply percentage discount
            discountAmount = (subtotal * validCoupon.discount_percentage) / 100;
          }

          setDiscount(discountAmount);
          setCouponError(""); // Clear any previous error
        } else {
          // Show an error message if the coupon can't be applied
          setCouponError(
            "Coupon can only be applied if its value is greater than or equal to the cart subtotal.",
          );
          setDiscount(0); // Don't apply any discount
        }
      } else {
        setDiscount(0);
        setCouponError("Invalid coupon code");
      }
    } catch (error) {
      console.error("Error fetching coupon:", error);
      setCouponError("There was an issue with applying the coupon");
    }
  };

  const handlePayment = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fill in all required fields.",
      });
      return;
    }

    const orderData = {
      user_id: userId,
      cart_items: items.map((item) => ({
        cart_item_id: item.cart_item_id,
        item_price: item.item_price,
      })),
      name: formData.firstName,
      street: formData.streetAddress,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      postal_code: formData.pinCode,
      mobile: formData.phone,
      email: formData.email,
      total_amount: discountedTotal, // Total amount after applying the discount

      // Billing address included
      bill_name: useShippingAddress ? formData.firstName : billingData.name,
      bill_street: useShippingAddress
        ? formData.streetAddress
        : billingData.street,
      bill_city: useShippingAddress ? formData.city : billingData.city,
      bill_state: useShippingAddress ? formData.state : billingData.state,
      bill_country: useShippingAddress ? formData.country : billingData.country,
      bill_postal_code: useShippingAddress
        ? formData.pinCode
        : billingData.postalCode,
      bill_mobile: useShippingAddress ? formData.phone : billingData.phone,
    };
    console.log("Order Data:", JSON.stringify(orderData, null, 2));
    try {
      const response = await axios.post(`${BASE_URL}place-order/`, orderData);

      const { razorpay_order_id, amount, currency } = response.data;

      if (!razorpay_order_id) {
        Swal.fire({
          icon: "error",
          title: "Order Error",
          text: "Unable to create the order. Please try again.",
        });
        return;
      }

      // Set up Razorpay options
      const options = {
        key: "rzp_live_SPsuUidAyMhcgx", // Your actual Razorpay key
        amount: amount, // Amount in paise
        currency: currency,
        name: "Vishu Shethra Industries",
        description: "Order Payment",
        order_id: razorpay_order_id,
        handler: async (response) => {
          const savingsText =
            totalSavedAllProducts > 0
              ? `Total amount you saved: ₹ ${totalSavedAllProducts.toLocaleString(
                  "en-IN",
                  { minimumFractionDigits: 2 },
                )} INR`
              : "";

          Swal.fire({
            icon: "success",
            title: "Order Placed",
            text: `Your order has been successfully placed! ${savingsText}`,
            confirmButtonText: "OK",
          }).then(() => {
            window.location.href = "/"; // Redirect to home page
          });
        },
        prefill: {
          name: formData.firstName,
          email: formData.email || "", // Added email check for prefill
          contact: formData.phone,
        },
        notes: {
          shipping_address: `${formData.streetAddress}, ${formData.city}, ${formData.state}, ${formData.pinCode}, ${formData.country}`,
          billing_address: useShippingAddress
            ? `${formData.streetAddress}, ${formData.city}, ${formData.state}, ${formData.country}, ${formData.pinCode}`
            : `${billingData.street}, ${billingData.city}, ${billingData.state}, ${billingData.country} , ${billingData.postalCode}`,
        },
        theme: {
          color: "#F37254",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error(
        "Error creating order:",
        error.response ? error.response.data : error.message,
      );
      const errorMessage = error.response
        ? error.response.data.message ||
          "There was an issue creating your order."
        : "Network error. Please try again.";

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });
    }
  };

  const totalSavedAllProducts =
    items.reduce((acc, product) => {
      const productSaved = (product.price * product.discount_percentage) / 100;
      return acc + productSaved * product.quantity; // Multiply by quantity
    }, 0) + discount; // Add the discount (if any)
  const handlePaymenterror = () => {
    Swal.fire({
      icon: "error",
      title: "Payment Unavailable",
      text: "Razorpay payment option is currently not available. Please try again later.",
      confirmButtonText: "OK",
      confirmButtonColor: "#d33",
    });
  };

  return (
    <div>
      <h2 className="text-center my-5">Payment</h2>
      <div className="checkout_section" id="accordion">
        <div className="container">
          <div className="checkout_form">
            <div className="row">
              <div className="col-lg-5 col-md-6">
                {/* Delivery Address Form */}
                <form action="#">
                  <h3>Delivery Address</h3>
                  <div className="checkout_form_input">
                    <label>Name *</label>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.firstName ? " input-error border-danger" : ""
                      }`}
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleDeliveryChange}
                      placeholder="Enter your name"
                    />
                  </div>
                  <div className="checkout_form_input">
                    <label>Email *</label>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.email ? " input-error border-danger" : ""
                      }`}
                      name="email"
                      value={formData.email}
                      onChange={handleDeliveryChange}
                      placeholder="Enter your email"
                    />
                  </div>

                  <div className="checkout_form_input">
                    <label>Street address *</label>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.streetAddress ? "input-error border-danger" : ""
                      }`}
                      name="streetAddress"
                      value={formData.streetAddress}
                      onChange={handleDeliveryChange}
                      placeholder="Enter your street address"
                    />
                  </div>

                  <div className="d-flex flex-column flex-md-row">
                    <div className="checkout_form_input col-12 col-md-4 me-md-1">
                      <label>Town / City *</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.city ? "input-error border-danger" : ""
                        }`}
                        name="city"
                        value={formData.city}
                        onChange={handleDeliveryChange}
                        placeholder="Enter your city"
                      />
                    </div>

                    <div className="checkout_form_input col-12 col-md-4 me-md-1">
                      <label>State *</label>
                      <input
                        type="text"
                        className={`form-control`}
                        name="state"
                        value={formData.state}
                        onChange={handleStateChange}
                        onFocus={() => setShowSuggestions(true)}
                        placeholder="Enter your state"
                      />
                      {showSuggestions && (
                        <ul className="suggestions-list">
                          {filteredStates.length > 0 ? (
                            filteredStates.map((state, index) => (
                              <li
                                key={index}
                                onClick={() => selectState(state)}
                                className="suggestion-item"
                              >
                                {state}
                              </li>
                            ))
                          ) : (
                            <li className="no-suggestions">
                              No suggestions found
                            </li>
                          )}
                        </ul>
                      )}
                    </div>

                    <div className="checkout_form_input col-12 col-md-4 ">
                      <label>Country / Region *</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.country ? "input-error border-danger" : ""
                        }`}
                        name="country"
                        value={formData.country}
                        onChange={handleDeliveryChange}
                        placeholder="Enter your country"
                      />
                    </div>
                  </div>

                  <div className="d-flex flex-column flex-md-row">
                    {/* PIN Code Input */}
                    <div className="checkout_form_input col-12 col-md-6 me-md-1">
                      <label>PIN Code *</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.pinCode ? "input-error border-danger" : ""
                        }`}
                        name="pinCode"
                        value={formData.pinCode}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,6}$/.test(value)) {
                            // Restricts to max 6 digits
                            handleDeliveryChange(e);
                          }
                        }}
                        placeholder="Enter your  PIN Code"
                      />
                    </div>

                    {/* Phone Input */}
                    <div className="checkout_form_input col-12 col-md-6">
                      <label>Phone *</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.phone ? "input-error border-danger" : ""
                        }`}
                        name="phone"
                        value={formData.phone}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d+$/.test(value)) {
                            // Allows only positive integers
                            handleDeliveryChange(e);
                          }
                        }}
                        placeholder="Enter your phone number"
                      />
                    </div>
                  </div>
                </form>

                <div className="mb-3">
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="sameAddress"
                      name="addressOption"
                      checked={useShippingAddress}
                      onChange={() => handleAddressOptionChange("same")}
                    />
                    <label className="form-check-label" htmlFor="sameAddress">
                      Same as shipping address
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="differentAddress"
                      name="addressOption"
                      checked={!useShippingAddress}
                      onChange={() => handleAddressOptionChange("different")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="differentAddress"
                    >
                      Use a different billing address
                    </label>
                  </div>
                </div>

                {/* Conditionally render the billing address form */}
                {!useShippingAddress && (
                  <form action="#">
                    <h3>Billing Address</h3>
                    <div className="checkout_form_input">
                      <label>Billing Name *</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.billingName ? "input-error border-danger" : ""
                        }`}
                        name="name"
                        value={billingData.name}
                        onChange={handleBillingChange}
                        placeholder="Enter billing name"
                      />
                    </div>
                    <div className="checkout_form_input">
                      <label>Billing Name *</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.billingemail ? "input-error border-danger" : ""
                        }`}
                        name="email"
                        value={billingData.email}
                        onChange={handleBillingChange}
                        placeholder="Enter billing email"
                      />
                    </div>

                    <div className="checkout_form_input">
                      <label>Billing Street Address *</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.billingStreet
                            ? "input-error border-danger"
                            : ""
                        }`}
                        name="street"
                        value={billingData.street}
                        onChange={handleBillingChange}
                        placeholder="Enter billing street address"
                      />
                    </div>

                    <div className="d-flex flex-column flex-md-row">
                      <div className="checkout_form_input col-12 col-md-4 me-md-1">
                        <label>Billing Town / City *</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.billingCity
                              ? "input-error border-danger"
                              : ""
                          }`}
                          name="city"
                          value={billingData.city}
                          onChange={handleBillingChange}
                          placeholder="Enter billing city"
                        />
                      </div>

                      <div className="checkout_form_input col-12 col-md-4 me-md-1">
                        <label>Billing State *</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.billingState
                              ? "input-error border-danger"
                              : ""
                          }`}
                          name="state"
                          value={billingData.state}
                          onChange={handleBillingChange}
                          placeholder="Enter billing state"
                        />
                      </div>

                      <div className="checkout_form_input col-12 col-md-4">
                        <label>Billing Country / Region *</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.billingCountry
                              ? "input-error border-danger"
                              : ""
                          }`}
                          name="country"
                          value={billingData.country}
                          onChange={handleBillingChange}
                          placeholder="Enter billing country"
                          onFocus={(e) => {
                            if (!billingData.country) {
                              handleBillingChange({
                                target: { name: "country", value: "" },
                              });
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="d-flex flex-column flex-md-row">
                      {/* Billing PIN Code Input */}
                      <div className="checkout_form_input col-12 col-md-6 me-md-1">
                        <label>Billing PIN Code *</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.billingPostalCode
                              ? "input-error border-danger"
                              : ""
                          }`}
                          name="postalCode"
                          value={billingData.postalCode}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,6}$/.test(value)) {
                              // Restricts to max 6 digits
                              handleBillingChange(e);
                            }
                          }}
                          placeholder="Enter billing  PIN Code"
                        />
                      </div>

                      {/* Billing Phone Input */}
                      <div className="checkout_form_input col-12 col-md-6">
                        <label>Billing Phone *</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.billingPhone
                              ? "input-error border-danger"
                              : ""
                          }`}
                          name="phone"
                          value={billingData.phone}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d+$/.test(value)) {
                              // Allows only positive integers
                              handleBillingChange(e);
                            }
                          }}
                          placeholder="Enter billing phone number"
                        />
                      </div>
                    </div>
                  </form>
                )}
              </div>

              <div className="col-lg-7 col-md-6">
                <div className="payment-order-summary-card">
                  <div className="payment-order-summary-header">
                    <h3>Your Order</h3>
                  </div>

                  {/* Products Table */}
                  <div className="payment-order-products-table">
                    <div className="payment-table-responsive">
                      <table className="payment-order-items-table">
                        <thead>
                          <tr>
                            <th className="payment-product-col">Product</th>
                            <th className="payment-qty-col">Qty</th>
                            <th className="payment-price-col">Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((product) => (
                            <tr key={product.id} className="payment-order-item">
                              <td className="payment-product-info">
                                <div className="payment-product-image">
                                  <img
                                    src={product.images[0]}
                                    alt={product.product_name}
                                  />
                                </div>
                                <div className="payment-product-details">
                                  <h4 className="payment-product-name">
                                    {product.product_name}
                                  </h4>
                                  {product.offer_type === "buy_x_get_y" ? (
                                    <span className="payment-offer-badge payment-bg-primary">
                                      Buy {product.buy_x} Get {product.get_y}{" "}
                                      Offer
                                    </span>
                                  ) : product.offer_type ===
                                      "discount_percentage" &&
                                    product.discount_percentage > 0 ? (
                                    <span className="payment-offer-badge payment-bg-success">
                                      {product.discount_percentage}% Off
                                    </span>
                                  ) : null}
                                </div>
                              </td>
                              <td className="payment-quantity">
                                {product.quantity}
                              </td>
                              <td className="payment-price">
                                ₹
                                {parseFloat(product.item_price).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                  },
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Coupon Section */}
                  <div className="payment-coupon-section">
                    <div className="payment-coupon-box">
                      <h4>
                        <i className="fas fa-tag"></i> Have a Coupon?
                      </h4>
                      <div className="payment-coupon-form">
                        <input
                          type="text"
                          className="payment-form-control"
                          value={couponCode}
                          onChange={(e) => setCouponCode(e.target.value)}
                          placeholder="Enter coupon code"
                        />
                        <button
                          type="button"
                          className="payment-btn payment-btn-primary"
                          onClick={applyCoupon}
                        >
                          Apply
                        </button>
                      </div>
                      {couponError && (
                        <div className="payment-coupon-error">
                          {couponError}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Order Totals */}
                  <div className="payment-order-totals">
                    <table className="payment-totals-table">
                      <tbody>
                        <tr>
                          <td>Cart Subtotal</td>
                          <td className="payment-text-right">
                            ₹
                            {parseFloat(subtotal).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}
                          </td>
                        </tr>

                        <tr>
                          <td>Delivery Charge</td>
                          <td className="payment-text-right">
                            {formData.state.trim() === "" ? (
                              <span className="payment-text-muted">
                                Enter shipping address
                              </span>
                            ) : (
                              `₹${parseFloat(deliveryCharge).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                },
                              )}`
                            )}
                          </td>
                        </tr>

                        {discount > 0 && (
                          <tr className="payment-discount-row">
                            <td>Coupon Discount</td>
                            <td className="payment-text-right payment-text-success">
                              -₹
                              {Math.abs(parseFloat(discount)).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                },
                              )}
                            </td>
                          </tr>
                        )}

                        <tr className="payment-total-row">
                          <th>Order Total</th>
                          <td className="payment-text-right">
                            ₹
                            {parseFloat(discountedTotal).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 2,
                              },
                            )}
                          </td>
                        </tr>

                        {totalSavedAllProducts > 0 && (
                          <tr className="payment-savings-row">
                            <th>Total Savings</th>
                            <td className="payment-text-right payment-text-success">
                              ₹
                              {totalSavedAllProducts.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                              })}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Action Buttons */}
                  <div className="payment-order-actions">
                    {/* <button
                      className="payment-btn payment-btn-success payment-btn-place-order"
                      onClick={handlePayment}
                      disabled={isLoading}
                    >
                      {isLoading ? "Processing..." : "Place Order"}
                    </button> */}

                   <button
  className="payment-btn payment-btn-success payment-btn-place-order"
  onClick={handlePayment}  // ← Change this to handlePayment
  disabled={isLoading}
>
  {isLoading ? "Processing..." : "Place Order"}
</button>
                    <button
                      className="payment-btn payment-btn-outline-secondary payment-btn-go-back"
                      onClick={() => navigate(-1)}
                    >
                      <IoArrowBack /> Go Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;
